import { createFileRoute } from "@tanstack/react-router";
import SidingReplacement from "@/pages/services/SidingReplacement";
import { seo, breadcrumbSchema, absoluteUrl } from "@/lib/seo";
import { buildFaqPageSchema, buildServiceSchema } from "@/lib/schema";
import { sidingReplacementFaqs } from "@/data/serviceFaqs";

export const Route = createFileRoute("/_site/services/siding-replacement")({
  head: () =>
    seo({
      title: "Siding Replacement in Minneapolis, MN | Cedar Creek Construction",
      description:
        "LP SmartSide, James Hardie, and vinyl siding replacement in Minneapolis & the Twin Cities. Licensed local crew, free estimates: (612) 298-9865.",
      path: "/services/siding-replacement",
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Services", path: "/siding" },
          { name: "Siding Replacement", path: "/services/siding-replacement" },
        ]),
        buildServiceSchema({
          name: "Siding Replacement in Minneapolis, MN",
          serviceType: "Siding Replacement",
          url: absoluteUrl("/services/siding-replacement"),
          description:
            "LP SmartSide, James Hardie fiber cement, and vinyl siding replacement for homes across Minneapolis and the Twin Cities metro, installed by a licensed local contractor.",
        }),
        buildFaqPageSchema(sidingReplacementFaqs),
      ],
    }),
  component: SidingReplacement,
});
